<template>
  <div class="header">
    <a class="fl logo" href="/">
      <img src="static/logo.png" height="20px">
    </a>
    <div class="fr">
      <i v-if="login" class="pencil alternate icon" v-on:click="edit"></i>
      <i v-if="login" class="times circle outline icon" v-on:click="addItem"></i>
      <a :href="ssourl" :target="target" class="fr" style="line-height: 25px;">{{username}}</a>
    </div>
  </div>
</template>

<script>
  export default {
		name: 'Header',
    data () {
      return {
        username:"Log in",
        ssourl:"/",
        target: "_self",
        login: false,
      }
    },
    methods: {
      addItem: function(){
        this.$parent.show()
      },
      edit: function(){
        this.$parent.edit()
      }
    },
    components: {
    }
	}
</script>

<style>
  .header i{
    color: #5f5f5f;
    vertical-align: bottom;
    margin-right: 15px !important;
    cursor: pointer;
  }
  .header .circle{
    transform:rotate(45deg);
    -ms-transform:rotate(45deg); 	/* IE 9 */
    -moz-transform:rotate(45deg); 	/* Firefox */
    -webkit-transform:rotate(45deg); /* Safari 和 Chrome */
    -o-transform:rotate(45deg); 	/* Opera */
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue